// extracted by mini-css-extract-plugin
module.exports = {"grid":"PressGrid-module-grid"};